import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import { OrderReviewContext } from './OrderReviewContext';
import DisplayObject from './DisplayObject';

const propTypes = {
  classes: PropTypes.object.isRequired,
};

function ValuationHistory({ classes }) {
  const {
    state: { valuationHistory },
  } = useContext(OrderReviewContext);
  const renameKeys = (obj, newKeys) => {
    const keyValues = Object.keys(obj).map(key => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  };
  const newKeys = { rcv: 'RCV', histChangeDateTime: 'Executed On', executedby: 'Executed By' };
  const renamedValuationHistory = valuationHistory?.map(vh => renameKeys(vh, newKeys));

  return (
    <Grid item xs={12} className={classes.container}>
      <Card className="border-left-green">
        <CardHeader
          className={classes.cardHeader}
          titleTypographyProps={{ className: classes.cardHeaderTitle }}
          title="Valuation History"
        />
        <CardContent className={classes.cardContent}>
          {renamedValuationHistory ? (
            <DisplayObject object={renamedValuationHistory} />
          ) : (
            <DisplayObject object={{ None: 'No valuation history was found.' }} />
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}

const styles = theme => ({
  container: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    padding: 1,
    flex: 1,
  },
  cardContent: {
    padding: '0 !important',
  },
  cardHeader: {
    padding: '12px',
    backgroundColor: '#fafafa',
  },
  cardHeaderTitle: {
    fontSize: '1rem',
    fontWeight: '700',
    textAlign: 'left',
    color: 'var(--jmi-blue)',
  },
});

ValuationHistory.propTypes = propTypes;
export default withStyles(styles)(withRouter(ValuationHistory));
